import { UnnamedWidget } from 'lib-node-amb-renderer';

//INFO: will be removed after Title Refi pilot
export class HiddenElementClass extends UnnamedWidget {
  text;
  constructor(props) {
    super(props);
    this.text = props.text;
  }
}

type HiddenElementProps = {
  text?: string;
};

const HiddenElement = ({ text }: Readonly<HiddenElementProps>) => {
  return <div hidden>{text}</div>;
};

export default HiddenElement;
